// plugins/env.js — bridges context into the service
import Vue from 'vue'
import { configureLogger, logger } from '~/utils/logger'

const prodpattern = /prod/i
const testpattern = /staging/i
const devpattern = /dev/i
const localpattern = /local/i

const storeEnvVars = env => [
  {
    qlikPublicUrl: `${env.qlikPublicUrl}`,
    ResourceUrl: `${env.ResourceUrl}`,
    FullQlikPublicUrl: `${env.FullQlikPublicUrl}`,
    FullResourceUrl: `${env.FullResourceUrl}`,
    baseURL: `${env.baseURL}`,
    httpProtocol: `${env.PROTOCOL}`,
    tlsPort: `${env.PORT}`,
    browserBaseURL: `${env.browserBaseURL}`,
    appEnv: `${env.appEnv}`,
    appID: `${env.appID}`,
    isStaging: testpattern.test(env.appEnv),
    isProd: prodpattern.test(env.appEnv),
    isDev: devpattern.test(env.appEnv),
    isLocal: localpattern.test(env.appEnv)
  }
]

var envVars

export default ({ app }, inject) => {
  envVars = storeEnvVars(app.$config)

  // Must run before any other plugin logs, so their logger.* calls are
  // gated by the level appropriate for this environment.
  configureLogger(envVars[0])

  logger.debug('storeEnvVars structureEnvVars: ', envVars)

  inject('env', envVars[0])

  Vue.config.devtools = envVars[0].isDev

  if (process.client) {
    const vue = new Vue()

    const hook =
      window.__VUE_DEVTOOLS_GLOBAL_HOOK__ ||
      (window.__VUE_DEVTOOLS_GLOBAL_HOOK__ = {})
    hook.Vue = vue.constructor

    logger.debug('Vue.config.devtools: ', Vue.config.devtools)
    logger.debug('window.__VUE_DEVTOOLS_GLOBAL_HOOK__: ', hook)
  }
}

export function getEnvVars() {
  return envVars[0]
}
